import React from 'react';
import { mdiClose, mdiEmailArrowRightOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Subscription, allOccurrences, isUserRecipient, Occurrence, Recipient } from './types';
import { Select } from '../../Select/Select';
import { IconButton } from '../../Button/IconButton';
import { UserAvatar } from '../../Avatar';

const occurrenceOptions = allOccurrences.map((occurrence) => ({
	label: occurrence.charAt(0).toUpperCase() + occurrence.slice(1),
	value: occurrence,
}));

export function SubscriptionList({ subscriptions, onDeleteSubscription, onChangeOccurrence }: {
    subscriptions: Subscription[],
    onDeleteSubscription: (index: string) => void,
	onChangeOccurrence: (index: string, occurrence: Occurrence) => void,
}) {
	return (
		<div className="flex flex-col items-start gap-4 self-stretch">
			<div className="flex items-center self-stretch">
				<span className="text-base text-text-primary font-medium tracking-[0.16px]">
					Current recipients
				</span>
			</div>
			<div className="flex flex-col items-start self-stretch">
				{subscriptions.map(({ id, recipient, occurrence }) => (
					<div key={id} className="flex items-center py-1 gap-2 self-stretch group hover:rounded-sm hover:bg-bg-interactive-light-bg-active_hover">
						<RecipientEntry recipient={recipient} />
						<div className="w-[1px] h-6 bg-borders-primary" />
						<Select
							value={occurrence}
							onChange={(newOccurrence) => onChangeOccurrence(id, newOccurrence)}
							options={occurrenceOptions}
							variant="borderless"
							transparent
						/>
						<IconButton
							icon={<Icon path={mdiClose} />}
							onClick={() => onDeleteSubscription(id)}
							className="flex p-1.5 items-start gap-2.5 invisible pointer-events-none group-hover:visible group-hover:pointer-events-auto"
							size="s"
						/>
					</div>
				))}
			</div>
		</div>
	);
}

function RecipientEntry({ recipient }: { recipient: Recipient }) {
	const isUser = isUserRecipient(recipient);
	return (
		<div className="flex items-center gap-2 w-full">
			<div className="flex p-0.5 justify-center items-center gap-2.5">
				{isUser ? <UserAvatar userId={recipient.id} /> : <Icon path={mdiEmailArrowRightOutline} size="20px" />}
			</div>
			<span className="text-sm text-text-primary">{isUser ? `${recipient.firstName} ${recipient.lastName}` : recipient.email}</span>
		</div>
	);
}
